module.exports = __webpack_public_path__ + "media/18.34ebac0e.mp3";